<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">Maintenance Work Order (SPK)
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="5">
                  <b-input-group >
                    <b-input-group-prepend><label>Work Order Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="Order Number"></b-form-input>
                  </b-input-group>
                </b-col>
              <b-col  lg="7">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-2">Request By &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.requestby" placeholder="Request By"></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>          
            <b-input-group >
              <b-input-group-prepend><label>Work Order Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>WorkOrder Title</label></b-input-group-prepend>
                <b-form-input v-model="tblData.inspectName" style="width:30% !important;" ></b-form-input>
                <b-input-group-prepend><span class="ml-2 pt-2">Asset Category &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>WorkOrder Detail </label></b-input-group-prepend>
                <b-form-input v-model="tblData.inspectDetail" placeholder='Detail Job/Task'></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
              <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier" style="width:30% !important;"></b-form-input>
              <b-input-group-prepend><span class="ml-1 pt-2">Status &nbsp;</span></b-input-group-prepend>
              <b-form-select v-model="tblData.status" :plain="true" :options="outstandSlct"></b-form-select>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-2" @click="refresh()" > Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined small 
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(orderdate)="data">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
        </template>

        <template v-slot:cell(costEstimate)="data">
          {{data.item.costEstimate | numFormat}}
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import workorder from "../../apis/maintenworko";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";

toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        status:"",
        postgroup:"",
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'orderdate',
        sortDesc: true,
        DimCol:'Dim1',
        outstand:''
      },
      model:{},
      outstandSlct : dropdown.openClose,
      categories:[]
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    
    tblFields(){
      const fields=[
          {
            key: "maintSpkNo",
            thStyle: "width:100px",
            label: "WorkOrder Number"
          },
          {
            key: "orderdate",
            thStyle: "width:90px",
            label: "WorkOrder Date"
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "inspectName",
            thStyle: "width:300px",
            label: "Description",
          },
          {
            key: "referDoc",
            label: "Maintenance Doc.#",
            thStyle: "width:140px",
            sortable: true
          },
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name",
          },
          {
            key: "catgname",
            label: "Category Assets",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asmodel",
            label: "Model/Type",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "asserial",
            label: "S/N",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "costEstimate",
            label: "Est.Maintenance Cost",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "requestby",
            thStyle: "width:100px",
            label: "Request By",
            sortable: true
          },
          {
            key: "mainteby",
            thStyle: "width:100px",
            label: "Checked By",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    catgid() {
      return this.tblData.catgid;
    },
  },
  watch:{
    catgid: function(newval){
      const catg = this.categories.find(c => c.value == newval)
      if (catg)
      {
        this.tblData.category=catg.text;
      }
    },
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      const [a] = await Promise.all([workorder.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
  },   
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.mwoList) {
            this.tblData[key] = filter.mwoList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.mwoList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await workorder.list(this.tblData);   
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.inspectName =  '';
        this.tblData.inspectDetail  =  '';
        this.tblData.nomor=  '';
        this.tblData.requestby=  '';
        this.tblData.catgid=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor_id', 'vendor', 'requestby', 'inspectName', 'inspectDetail', 'status', 'catgid'];
      let filtered = false;
      const mwoList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              mwoList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          mwoList.page=this.tblData.page;
          mwoList.limit=this.tblData.limit;
          mwoList.sortBy=this.tblData.sortBy;
          mwoList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.mwoList=mwoList;
          this.$store.commit("filter", filter);
      }
    },    
    add(){
      this.saveFilter();
      router.push({ name: "fixedasset.maintworkorderfrm" });
    },
    edit: function() {
        if (this.model.maintSpkKey) {
          this.saveFilter();
          router.push({ name: "fixedasset.maintworkorderfrm", params: { maintSpkKey: this.model.maintSpkKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.maintSpkKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await workorder.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      // if (this.model.maintSpkKey == record.maintSpkKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    print: async function()
    {
      if (this.model.maintSpkKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await workorder.print(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await workorder.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        // router.push({name:'procurement.home'});
          router.push("home");
    }

  }
};
</script>
